import isPropValid from '@emotion/is-prop-valid';
import { Card as MuiCard, CardProps as MuiCardProps, styled } from '@mui/material';
import { SizingProps, SpacingProps, compose, sizing, spacing } from '@mui/system';
import { FC } from 'react';
import { BorderMapper } from '../../../common/mapper/BorderMapper';
import { BorderColor } from '../../../common/model/BorderColor';
import { Loading } from '../../feedback/progress/Loading';

type Props = SizingProps &
  SpacingProps &
  MuiCardProps & {
    borderColor?: BorderColor;
    disabled?: boolean;
    disabledHover?: boolean;
    fullHeight?: boolean;
    highlightColor?: string;
    isLoading?: boolean;
    loadingPadding?: string;
    noOutline?: boolean;
  };

const CardStyled = styled(MuiCard, {
  shouldForwardProp: isPropValid,
})<Props>`
  ${({ borderColor, noOutline, disabled, theme }): string =>
    noOutline && !disabled
      ? `box-shadow: ${theme.shadows[1]};`
      : `border: 1px solid ${BorderMapper.colors(theme, borderColor ?? 'default')};  box-shadow: none;`};
  border-radius: 4px;
  height: ${({ fullHeight }: Props): string | undefined => (fullHeight ? '100%' : undefined)};

  ${({ highlightColor }: Props): string =>
    highlightColor
      ? `
  border-radius: 5px;
  border-top-width: 6px;
  border-top-style: solid;
  border-top-color: ${highlightColor ?? 'default'};
    `
      : ''}
  &:hover {
    ${({ theme, noOutline, disabledHover }): string => `
    cursor: ${noOutline && !disabledHover ? 'pointer' : 'auto'};
    box-shadow: ${noOutline && !disabledHover ? theme.shadows[2] : undefined};
    `}
  }

  ${({ theme, disabled }): string => `
    background-color: ${disabled ? theme.palette.grey[50] : undefined};
    `}
  ${compose(spacing, sizing)}
`;

export const Card: FC<Props> = ({ isLoading, children, loadingPadding = '8vh 0', ...props }) => (
  <CardStyled {...props}>
    <Loading isLoading={isLoading} size="small" p={loadingPadding} />
    {isLoading ? null : children}
  </CardStyled>
);
